module.exports = __webpack_public_path__ + "img/ic-lang-black.e5bad189.svg";